/* eslint-disable no-console */
import { isDevelopment, isTesting } from '~/utils/environment.utils';

function reportToDataDog(name: string, context: { [key: string]: any }) {
    const datadog = window.DD_RUM;

    if (!datadog || !datadog.addAction) {
        if (isDevelopment() || isTesting()) {
            console.error('Could not report action to logger', name, context);
        }
        return;
    }
    datadog.addAction(name, context);
}

export interface IReportActionProps {
    name: string;
    context?: { [key: string]: any };
}

export function reportAction(props: IReportActionProps) {
    const { name, context = {} } = props;

    if (!name) {
        if (isDevelopment() || isTesting()) {
            console.error('name is required and was not provided');
        }
        return;
    }

    reportToDataDog(name, context);

    if (isDevelopment() || isTesting()) {
        console.log('Report action to logger: ', name, context);
    }
}
